import { Getters } from './types'

const getters: Getters = {
  modal: (state) => (name: string) => state.modals[name],
}

export default getters
